// Feeds resolved lifecycle paint to the board.
//
// Mirrors `NodeColoringProvider`: a paint-only channel the board reads to
// restyle nodes without touching layout. Resolution is memoised on
// (windows, scrub point) alone, so a scrub tick repaints and never re-solves —
// the whole no-reflow guarantee lives in that dependency list.

import { type ReactNode } from "react";
import type { LifecycleWindow, Timeline } from "@archlang/engine";
import { LifecycleContext, useResolvedLifecyclePaint } from "./useLifecycleState.js";

export function LifecycleProvider({
  windows,
  timeline,
  children,
}: {
  /** Scrub-independent windows from the projection plan. */
  readonly windows: ReadonlyMap<string, LifecycleWindow> | undefined;
  /** The model's derived marker axis — supplies the default scrub point (`now`)
   *  and the marker text a sunset badge echoes. */
  readonly timeline?: Timeline;
  readonly children: ReactNode;
}) {
  const paint = useResolvedLifecyclePaint(windows, timeline);
  return <LifecycleContext.Provider value={paint}>{children}</LifecycleContext.Provider>;
}
